import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Drawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';
import Toolbar from '@mui/material/Toolbar';
import Logo from '../Helpers/Logo';
import CloseIcon from '@mui/icons-material/Close';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import NavigationItemList from './NavigationItemList';
import SendIcon from '@mui/icons-material/ArrowForward';
import { useHistory } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import { shopByCardType, shopByCategory, ShopByCollection, navigationCollectionHandle, secondaryNavigationOptions } from 'components/Navigation/libNavigation';
import DynamicCollection from 'components/Collection/DynamicCollection';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 400,
      [theme.breakpoints.down('md')]: {
        width: '100vw',
        paddingLeft: theme.spacing(1.5),
      },
    },
    toolbar: {
      minHeight: 60,
      padding: theme.spacing(0, 2),
      display: 'flex',
      justifyContent: 'space-between',
    },
  }),
);

interface SecondLayerDrawerProps {
  status: boolean;
  onBack: () => void;
  onClose: () => void;
}

const SecondLayerDrawer: React.FC<SecondLayerDrawerProps> = ({ status, onClose = () => {}, onBack }) => {
  const classes = useStyles();
  const history = useHistory();

  const seeAllGiftCards = () => {
    onClose();
    history.push('/corporate');
  };

  return (
    <Drawer open={status} anchor="right" onClose={onClose}>
      <div className={classes.root} role="presentation" onKeyDown={onClose}>
        <Toolbar className={classes.toolbar}>
          <Logo />
          <IconButton edge="end" color="primary" aria-label="close" onClick={onClose} size="large">
            <CloseIcon sx={{ fontSize: 30 }} />
          </IconButton>
        </Toolbar>
        <Stack sx={{ pl: 2 }}>
          <Stack flexDirection="row" sx={{ mb: 1.5 }}>
            <IconButton color="primary" aria-label="back" onClick={onBack} sx={{ ml: -1.5 }} size="large">
              <ArrowBackIcon />
            </IconButton>
            <Stack sx={{ flexGrow: 1 }} />
          </Stack>
          <DynamicCollection handle={navigationCollectionHandle} cardSize="extrasmall" onCloseDrawer={onClose} />
          <NavigationItemList title={secondaryNavigationOptions[0].title} items={shopByCardType} onClose={onClose} />
          <Divider sx={{ my: 3 }} />
          <NavigationItemList title={secondaryNavigationOptions[1].title} items={shopByCategory} hasTwoColumn={true} onClose={onClose} />
          <Divider sx={{ my: 3 }} />
          <NavigationItemList title={secondaryNavigationOptions[2].title} items={ShopByCollection} hasTwoColumn={true} onClose={onClose} />
          <Stack alignItems="flex-start" sx={{ my: 4 }}>
            <Button onClick={seeAllGiftCards} size="medium" color="primary" endIcon={<SendIcon />} sx={{ padding: 0 }}>
              See All Gift Cards
            </Button>
          </Stack>
        </Stack>
      </div>
    </Drawer>
  );
};

export default SecondLayerDrawer;
